export default __webpack_public_path__ + "static/media/tech-multiple-segments-1.13efb064.png";